var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.347,
    height: 22.342,
    viewBox: "0 0 22.347 22.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M11.171,7.68A5.728,5.728,0,1,0,16.9,13.409,5.719,5.719,0,0,0,11.171,7.68Zm0,9.452a3.724,3.724,0,1,1,3.724-3.724,3.731,3.731,0,0,1-3.724,3.724Zm7.3-9.687A1.336,1.336,0,1,1,17.133,6.11,1.333,1.333,0,0,1,18.469,7.446ZM22.263,8.8a6.612,6.612,0,0,0-1.8-4.681,6.655,6.655,0,0,0-4.681-1.8c-1.845-.1-7.373-.1-9.218,0a6.646,6.646,0,0,0-4.681,1.8A6.634,6.634,0,0,0,.073,8.8c-.1,1.845-.1,7.373,0,9.218a6.612,6.612,0,0,0,1.8,4.681,6.664,6.664,0,0,0,4.681,1.8c1.845.1,7.373.1,9.218,0a6.612,6.612,0,0,0,4.681-1.8,6.655,6.655,0,0,0,1.8-4.681c.1-1.845.1-7.368,0-9.213ZM19.88,19.994a3.77,3.77,0,0,1-2.124,2.124c-1.471.583-4.96.449-6.586.449s-5.12.13-6.586-.449a3.77,3.77,0,0,1-2.124-2.124c-.583-1.471-.449-4.96-.449-6.586s-.13-5.12.449-6.586A3.77,3.77,0,0,1,4.585,4.7c1.471-.583,4.96-.449,6.586-.449s5.12-.13,6.586.449A3.77,3.77,0,0,1,19.88,6.823c.583,1.471.449,4.96.449,6.586S20.463,18.529,19.88,19.994Z",
    transform: "translate(0.005 -2.238)",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramGrey);
export default __webpack_public_path__ + "static/media/instagram_grey.ee29fae7c02384c71d72dac9e5c74a26.svg";
export { ForwardRef as ReactComponent };